import { render, staticRenderFns } from "./LinkWithApisConversations.vue?vue&type=template&id=6ff2f81b&scoped=true"
import script from "./LinkWithApisConversations.vue?vue&type=script&lang=js"
export * from "./LinkWithApisConversations.vue?vue&type=script&lang=js"
import style0 from "./LinkWithApisConversations.vue?vue&type=style&index=0&id=6ff2f81b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2f81b",
  null
  
)

export default component.exports